/* New version JS Class par Copilot */
class IkadiaCarouselReact {
    constructor() {
        
        document.addEventListener("DOMContentLoaded", () => this.init());
        // Provisoire, voir pour appeler le fichier dans le footer et supprimer la condition

        //this.init();
        
    }

    init() {
        const carousels = document.querySelectorAll('.wp-block-ikadia-carousel-react.swiper');
        if (!carousels.length) return;

        carousels.forEach((element, i) => {
            // Add a unique class for each carousel
            const diff = 'icr-' + i;
            element.classList.add(diff);

            // Remove slides with data-masquer="y"
            const slides = element.querySelectorAll('.swiper-slide');
            slides.forEach((slide) => {
                if (slide.getAttribute('data-masquer') === 'y') {
                    slide.remove();
                }
            });

            // Swiper options
            let loop = false;
            if (element.getAttribute('data-loop') === 'y' && element.getAttribute('data-scrollbar') != 'y') {
                loop = true;
            }

            let autoPlay = false;
            if (element.getAttribute('data-autoplay') === 'y') {
                autoPlay = { delay: 5000 };
            }

            let effet = false;
            if (element.getAttribute('data-fade') === 'y') {
                effet = 'fade';
            }

            // Initialize Swiper
            new Swiper('.swiper.' + diff, {
                loop: loop,
                effect: effet,
                simulateTouch: false,
                autoplay: autoPlay,
                navigation: {
                    nextEl: '.' + diff + ' .swiper-button-next',
                    prevEl: '.' + diff + ' .swiper-button-prev',
                },
                pagination: {
                    el: '.' + diff + ' .swiper-pagination',
                    clickable: true,
                },
                scrollbar: {
                    el: '.' + diff + ' .swiper-scrollbar',
                    draggable: true,
                }
            });
        });
    }
}

//if(document.querySelector('.wp-block-ikadia-carousel-react')) {
    const blockCarouselReact = new IkadiaCarouselReact();
//};



// /* Old version Dom ready + jQuery */
// document.addEventListener("DOMContentLoaded", function() {
//   if(document.getElementsByClassName('wp-block-ikadia-carousel-react').length !== 0) {

//     let swipers = document.querySelectorAll('.wp-block-ikadia-carousel-react.swiper');

//     swipers.forEach((element, i) => {
//       /* Ajoute une classe pour les différencier si besoin */
//       let diff = 'icr-' + i
//       element.classList.add(diff);

//       let slides = element.querySelectorAll('.swiper-slide');
//       slides.forEach((slide, i) => {
//         if (slide.getAttribute('data-masquer') === 'y') {
//             slide.remove();
//         }
//       });

//       /* Variables fonctionnalités */
//       let loop = false
//       if (element.getAttribute('data-loop') === 'y' && element.getAttribute('data-scrollbar') != 'y') {
//           loop = true;
//       }
         
//       let autoPlay = false
//       if (element.getAttribute('data-autoplay') === 'y') {
//           autoPlay = { delay: 5000 };
//       }

//       let effet = false
//       if (element.getAttribute('data-fade') === 'y') {
//           effet = 'fade';
//       }

//       /* Initialisation du swiper */
//       swipers[i] = new Swiper('.swiper.' + diff, {
//         loop: loop,
//         effect: effet,
//         simulateTouch: false,
//         autoplay: autoPlay,
//         navigation: {
//             nextEl: '.' + diff + ' .swiper-button-next',
//             prevEl: '.' + diff + ' .swiper-button-prev',
//         },
//         pagination: {
//             el: '.' + diff + ' .swiper-pagination',
//             clickable: true,
//         },
//         scrollbar: {
//             el: '.' + diff + ' .swiper-scrollbar',
//             draggable: true,
//         }
//       });
//     });
//   }
// })
